import React from 'react';
import { Col } from 'react-bootstrap';
import find from 'lodash.find';
import { connect } from 'react-redux';
import * as Maps from '../../../store/map';

function MainBet(props) {
    const handleToggle = (e) => {
        e.preventDefault();

        let { bet, fixture, market, provider } = props;
        let { fixtures } = props.betslip;

        if (
            find(fixtures, {
                fixtureId: fixture.FixtureId,
                markets: [{ Id: market.Id, bets: [{ Id: bet.Id }] }],
            })
        ) {
            props.removeBet(fixture, market, bet, provider.Id);
        } else {
            props.addBet(fixture, market, bet, provider.Id);
        }
    };

    let { bet, fixture, market } = props;
    let { fixtures } = props.betslip;
    let line = bet.Line ? '(' + bet.Line + ')' : null;

    let isActive = find(fixtures, {
        fixtureId: fixture.FixtureId,
        markets: [{ Id: market.Id, bets: [{ Id: bet.Id }] }],
    })
        ? 'active'
        : '';

    return (
        <Col md="auto" id={'bet-' + bet.Id} className={'p-2 pl-3 pr-3 ml-1 border ripple-bet ' + isActive} onClick={handleToggle} key={bet.Id}>
            <span className="left odd-name">
                {bet.Name}
                {line}
            </span>
            <span className="right odd-price">{parseFloat(bet.Price).toFixed(2)}</span>
        </Col>
    );
}

export default connect(Maps.mapBetslipStateToProps, Maps.mapBetslipDispatchToProps)(MainBet);
